import { render, staticRenderFns } from "./IncidentReportDetailsView.vue?vue&type=template&id=35eae83c&scoped=true&"
import script from "./IncidentReportDetailsView.vue?vue&type=script&lang=js&"
export * from "./IncidentReportDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eae83c",
  null
  
)

export default component.exports